<template>
  <div class="sion-personnel" v-loading.fullscreen.lock="loading">
    <div class="sino-panel sion-peple">
      <div class="panel-top" ref="header">
        <i class="cubeic-back" @click="back"></i>
        <!-- <el-input placeholder="请输入关键字搜索" prefix-icon="el-icon-search" v-model="seach"></el-input> -->
        <el-input prefix-icon="el-icon-search" v-model="seach"></el-input>
        <div class="search-btn" @click="search">搜索</div>
      </div>
      <div class="panel-content">
          <div class="panel-scroll">
            <div class="scroll-aside" v-show="role!=2&&officeData.length>0">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in officeData"
                :key="index"
                @click="selectOffice(item)"
              >
                <span class="management-name">{{item.name}}</span>
                <span>({{item.totalNum}})</span>
              </div>
            </div>
            <div class="scroll-panel" ref="scrollView">
              <div class="panel-item" v-for="item in staffListData" :key="item.id">
                <div class="item item-radio">
                  <cube-checkbox v-model="item.check" :option="item.option"></cube-checkbox>
                </div>
                <div class="item item-phone">
                  <img v-if="item.photo" :src="item.photo" alt />
                  <img v-else src="@/images/doctor.png" alt srcset />
                </div>
                <div class="item item-info">
                  <div @click="getPersonDetail(item)">
                    <div class="info-name">{{item.staffName}}</div>
                    <div class="info-number">性别：{{item.sex == "2" ? "女" : "男"}}</div>
                  </div>
                  <div class="info-number" @click="callTel(item.phone)">手机号:{{item.phone}}</div>
                </div>
              </div>
              <div
                class="load-more mr-bottom"
                v-if="totalSum>staffListData.length"
                @click="loadMore"
              >点击加载更多</div>
              <div class="load-more mr-bottom" v-else>没有更多了</div>
            </div>
          </div>
      </div>
      <div class="sino-footer-new" ref="footer">
        <div class="footer-tip">提交后不可更换报名类型</div>
        <div class='sino-footer'>
          <div class="footer-box election">
            <cube-checkbox v-model="allCheck">全选</cube-checkbox>
          </div>
          <el-button class="footer-box transfer" :disabled="submitLoading&&!submitLoadingNow" v-loading="submitLoading&&!submitLoadingNow" @click="transfer">确定</el-button>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import {
  officeTreeData,
  getStaffListForSignup,
  officeTransfer
} from "@/common/api";
export default {
  data() {
    return {
      allCheck: false,
      seach: "",
      loading: false,
      officeData: [],
      activeData: [],
      staffListData: [],
      currentData: 15,
      currentDepartment: "",
      currentDepartmentItem: {},
      unionId: JSON.parse(localStorage.getItem("loginInfo")).unionId,
      height:'',
      role:JSON.parse(localStorage.getItem("loginInfo")).identity,
      pageSize:15,
      currentPage:1,
      totalSum:0, // 列表总数据
      checkedItem: [],
      allCheckItem: [],
      submitLoading:false
    };
  },
  mounted() {
    // let headerHeight=this.$refs.header.offsetHeight;
    // let footerHeight=this.$refs.footer.offsetHeight;
  },
  watch: {
    allCheck(value) {
      if(value){
        this.allCheckItem.push(this.currentDepartment);
      }else{
        this.allCheckItem.indexOf(this.currentDepartment) !== -1 && this.allCheckItem.splice(this.allCheckItem.indexOf(this.currentDepartment), 1)
      }
      this.staffListData.forEach(item => {
        if (item.signupStatus == 0) {
          if (value) {
            this.checkedItem.push(item);
            item.check = true;
          }else {
            this.checkedItem.splice(this.checkedItem.indexOf(item), 1)
            item.check = false;
          }
        }
      })
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    seach(value) {
      if (!value) {
        this.staffListData.forEach(item => {
          if (item.check) {
            this.checkedItem.push(item);
          }
        });
        this.staffListData=[];
        this.getAppStaffList(this.currentDepartmentItem);
      }
    }
  },
  props: {
    signupInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    activityId: "",
    deptId:"",
    selectedGroupUnionId:'',
    submitLoadingNow:false,
  },
  created() {
    this.getAppStaffList(this.currentDepartmentItem);
    this.getOfficeTree();
  },
  methods: {
    loadMore() {
      this.currentPage++;
      this.getAppStaffList(this.currentDepartmentItem);
    },

    getOfficeTree() {
      this.officeData=[];
      officeTreeData({
        unionId: this.unionId,
        identity:JSON.parse(localStorage.getItem("loginInfo")).identity,
      }).then(res => {
        if (res.code == 200) {
      
          res.data.forEach((item, index) => {
            if (index == 0) {
              item.active = true;
            } else {
              item.active = false;
            }
            if (item.parentId != "#") {
              this.activeData.push({
                content: item.name,
                id: item.id,
                parentId: item.parentId,
                parentName: item.parentName,
                type: item.type
              });
            } 
          });
          
          if(this.role=='2'){
            if(res.data&&res.data.length>0){
              res.data.forEach(item =>{
                if(item.id==this.deptId){
                  this.officeData.push(item);
                }
              })
            }
          }else{
            this.officeData = res.data;
          }
          
          // 不展示分会,（3权限）
          if(this.role=='3'){
            // this.officeData.shift();
          }

          // 某个分会下的科室（4,5权限）
          if(this.role=='4'||this.role=='5'){
            let arr=[];
            res.data&&res.data.map(item=>{
              if(item.parentId==this.selectedGroupUnionId||item.id===this.selectedGroupUnionId)arr.push(item)
            })
            this.officeData = arr;
          }
         

          // 默认选中第一个科室
          if(this.officeData&&this.officeData.length){
            this.selectOffice(this.officeData[0])
          }
        }
      });
    },
    getPersonDetail(option) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id: option.id,
          source: "pepole"
        }
      });
    },
    back() {
      this.$emit("back");
    },
    getAppStaffList(item,name) {
      const {id}=item;
      // this.currentData = 20;
      // this.$refs.scrollView.scrollTop = 0;
      this.loading = true;
      // 如果是分会组长,deptId 从父元素传值;如果是别的角色，deptId应该是点击tree树的值
      let deptId="";
      if(this.role=='2'){
        deptId=this.deptId;
      }else{
        deptId=this.currentDepartment;  
        if(deptId==this.unionId){
          deptId=""
        }  
      };
      // 五级管理员，点击分会(level==2)时，不传deptId
      if(this.role=='5'&&item.level=='2'){
        deptId=""
      }
      let {groupId} =this.signupInfo;
      groupId=groupId&&groupId.indexOf('_')>=0?groupId.split('_')[0]:groupId;
      getStaffListForSignup({
        unionId:this.selectedGroupUnionId||JSON.parse(localStorage.getItem("loginInfo")).unionId,
        staffName: name ? name : "",
        activityId: this.activityId,
        deptId:deptId,
        groupId:groupId,
        currentPage:this.currentPage,
        pageSize:15,
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          res.data.list.forEach(item => {
            const value = this.checkedItem.filter((checkItem) => {
              return checkItem.id === item.id
            });
            item.check = value.length > 0 ? true: false;
            item.option = {
              label: "",
              disabled: item.signupStatus == 1 ? true : false
            };
          });
          let list=res.data.list;
          this.totalSum=res.data.sum;
          this.staffListData=[...this.staffListData,...res.data.list];
          let map = new Map()
          this.staffListData = this.staffListData.filter(key => !map.has(key.id) && map.set(key.id, 1))
        } else {
          this.loading = false;
        }
      });
    },
    selectOffice(item) {
      const currentDept = this.allCheckItem.filter((value) => {
        return value === item.id
      });
      this.allCheck = currentDept.length > 0 ? true:false;
      this.staffListData.forEach(item => {
        if (item.check) {
          this.checkedItem.push(item);
        }
      });
      this.staffListData=[];
      this.currentPage=1;
      this.officeData.forEach(item => {
        item.active = false;
      });
      item.active = true;
      this.currentDepartment = item.id;
      this.currentDepartmentItem=item;
      if(this.seach){
        this.currentDepartment = item.id;
        this.currentDepartmentItem=item;
        this.seach = "";
      }else{
        this.getAppStaffList(item);
      }
    },
    transfer() {
      var self = this;
      // let checkItem = [];
      let signedList=[];
      this.checkedItem=[];
      this.staffListData.forEach(item => {
        if (item.check) {
          this.checkedItem.push(item);
        }
        if(item.signupStatus==1){
          signedList.push(item);
        }
      });
      // let obj = {};
      // this.checkedItem = this.checkedItem.reduce((cur,next) => {
      //     obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
      //     return cur;
      // },[])
      // let num = "";
      // if (typeof this.signupInfo.signupStaff == "object") {
      //   num = this.signupInfo.signupStaff.length;
      // } else {
      //   num = 0;
      // }
      // if (num >= 0) {
      //   if (this.signupInfo.maxNum - num < this.checkedItem.length) {
      //     toast(this, `当前活动人数超过最大限制`, "error");
      //     return;
      //   }
      // }

      if (this.checkedItem.length == 0) {
        // this.$emit("back");
        toast(this, `请选择人员`, "error");
        return;
      }
      this.submitLoading=true;
      this.$emit("saveSignup", this.checkedItem,this.currentDepartment,signedList);
    },

    //模糊搜索
    search() {
      this.currentPage=1;
      this.staffListData=[];
      if(this.seach) {
        this.getAppStaffList(this.currentDepartmentItem, this.seach);
      }
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.sion-personnel{
  height: 100vh;
  width: 100vw;
  .sino-panel{
    padding:0;
  }
}

.sino-footer-new {
  width: 100%;
  height: 80px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  bottom: 0;
  .cube-btn {
    width: 90%;
    border-radius: 0.16rem;
    margin:0 auto;
  }
  .footer-tip {
    height: 24px;
    background: #FF4B4B;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 24px;
  }
  .election {
    flex: 5;
    .cube-checkbox-wrap {
      width: 40%;
    }
  }
  .transfer {
    flex: 2;
    background: rgba(56, 199, 196, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    &:active {
      background: rgba(56, 199, 196, 0.5);
    }
  }

  .footer-box {
    height: 100%;
  }
  .cube-checkbox-input{
    // display: flex !important;
    // align-items: center !important;
  }
}

.panel-top {
  height: 59px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 0.6rem;
  .cubeic-back{
    margin-right:10px;
  }
  .search-btn {
    margin-left:10px;
    font-size:16px;
    color: #999;
    white-space: nowrap;
  }
  .el-input{
    display:flex;
    align-items:center;
    justify-content:flex-start;
  }
  .el-input__inner:focus{
    border-color: #38c7c4;
    outline: 0;
  }
  .el-input__inner {
    height: 32px;
    border-radius:16px;
    background: rgba(239, 239, 244, 1);
  }

  .el-input__prefix, .el-input__suffix {
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // -webkit-transition: all .3s;
    // height: 100% ;
    // color: #C0C4CC ;
    // text-align: center;
  }
  .el-input__icon{
    line-height: 32px;
  }
  // input::-webkit-input-placeholder{
  //   line-height: 32px !important;
  // }
  input{
    padding: 8px 0.8rem !important;
    height: 30px !important;
    font-size: 14px !important;
    line-height: 14px !important;
  }
}

.sion-peple .panel-content {
  height:calc(100% - 80px - 59px);
  overflow-y:scroll;
  .panel-scroll {
    height: 100%;
    display: flex;
    .scroll-aside {
      height: 100%;
      overflow: auto;
      flex: 2;
      .aside-item {
        text-align: center;
        // height: 60px;
        padding:10px;    
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;   
      }
      .item-active {
        background: #ffffff !important;
      }
    }

    .scroll-panel {
      flex: 5;
      height: 100%;
      overflow: auto;
      background: #fff;

      .panel-item {
        display: flex;
        height: 71px;
        padding: 0.15rem 0;
        background: #ffffff;

        .item-radio {
          display: flex;
          align-items: center;
          flex: 1;

          .cube-checkbox {
            padding: 0 0 0 0.16rem;
          }
        }

        .item-phone {
          display: flex;
          align-items: center;
          flex: 2;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item-info {
          flex: 4;
          border-bottom: 1px solid #e5e5e5;
          margin-left: 0.3rem;

          .info-name {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(53, 53, 53, 1);
            width:132px;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分文字以...显示 */
          }
          .info-number {
            height: 20px;
            line-height: 20px;
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
          }
        }
      }
    }
  }
 
}
.sion-peple .cube-checkbox-ui {
    margin-top: 17px;
}
.cube-action-sheet-list {
  height: 151px;
  overflow: auto;
  touch-action: auto;
}

.cube-action-sheet-space {
  height: 0.03rem;
}

.cube-action-sheet-title {
  background: rgba(232, 232, 241, 1);
  color: rgba(136, 136, 136, 1);
  height: 0.2rem;
  line-height: 0.2rem;
  font-size: 15px;
}

.management-name {
  display: inline-block;
  font-size: 14px;
  line-height:18px;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
}

</style>